import React from 'react';

const useActiveTab = ({
  selectedKey,
  data,
  onFilter
}) => {
  const refs = React.useRef([]);
  const lineRef = React.useRef(null);
  React.useEffect(() => {
    const idxSelect = data.findIndex(onFilter);

    if (idxSelect !== -1 && lineRef.current) {
      const activeTab = refs.current[idxSelect];

      if (activeTab) {
        lineRef.current.style.left = activeTab.offsetLeft + 'px';
        lineRef.current.style.width = activeTab.offsetWidth + 'px';
      }
    }
  }, [selectedKey, data, onFilter]);
  return {
    lineRef,
    refs
  };
};

export default useActiveTab;